/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { getEmpresaById, getUsuarios, getPlantillas, crearPlantilla, actualizarPlantilla, eliminarPlantilla, getHitosConfig, crearHitoConfig, actualizarHitoConfig, eliminarHitoConfig, actualizarEmpresa, subirLogo } from '../lib/db';
import { supabase } from '../lib/supabase';

const VARIABLES = ['{conductor}', '{unidad}', '{ruta}', '{ubicacion}', '{eta}', '{cliente}', '{placas}'];

export default function Configuracion({ hitos: hitosProp, setHitos: setHitosProp, empresaId }) {
  const [activeTab, setActiveTab] = useState('empresa');

  // Empresa
  const [empresa, setEmpresa] = useState({ nombre: '', rfc: '', telefono: '', email: '', logo_url: '' });

  // Usuarios
  const [usuarios, setUsuarios] = useState([]);
  const [showInvitar, setShowInvitar] = useState(false);
  const [invitacion, setInvitacion] = useState({ email: '', nombre: '', rol: 'ejecutivo' });
  const [enviandoInvitacion, setEnviandoInvitacion] = useState(false);
  const [mensajeInvitacion, setMensajeInvitacion] = useState('');

  // Hitos
  const [hitos, setHitosLocal] = useState(hitosProp || []);
  const [editandoHito, setEditandoHito] = useState(null);
  const [showNuevoHito, setShowNuevoHito] = useState(false);
  const [draggingHito, setDraggingHito] = useState(null);
  const [nuevoHito, setNuevoHito] = useState({ nombre: '', fotos: false, aprobacion: 'manual', palabras_clave: '' });

  // Plantillas
  const [plantillas, setPlantillas] = useState([]);
  const [editandoPlantilla, setEditandoPlantilla] = useState(null);
  const [editData, setEditData] = useState({ texto: '', hito_nombre: '' });
  const [showNuevaPlantilla, setShowNuevaPlantilla] = useState(false);
  const [nuevaPlantilla, setNuevaPlantilla] = useState({ titulo: '', hito_nombre: '', texto: '' });
  const textareaEditRef = useRef(null);
  const textareaNuevoRef = useRef(null);

  const setHitos = (val) => { setHitosLocal(val); if (setHitosProp) setHitosProp(val); };

  useEffect(() => {
    if (!empresaId) return;
    const cargar = async () => {
      const { data: emp } = await getEmpresaById(empresaId);
      if (emp) setEmpresa({ nombre: emp.nombre || '', rfc: emp.rfc || '', telefono: emp.telefono || '', email: emp.email || '', logo_url: emp.logo_url || '' });
      const { data: users } = await getUsuarios(empresaId);
      if (users) setUsuarios(users);
      const { data: hitosDB } = await getHitosConfig(empresaId);
      if (hitosDB && hitosDB.length > 0) setHitos(hitosDB);
      const { data: plantillasDB } = await getPlantillas(empresaId);
      if (plantillasDB) setPlantillas(plantillasDB);
    };
    cargar();
  }, [empresaId]);

  const insertarVariable = (variable, ref, texto, setTexto) => {
    const el = ref.current;
    if (!el) { setTexto(texto + variable); return; }
    const start = el.selectionStart;
    const end = el.selectionEnd;
    const nuevo = texto.substring(0, start) + variable + texto.substring(end);
    setTexto(nuevo);
    setTimeout(() => { el.selectionStart = el.selectionEnd = start + variable.length; el.focus(); }, 0);
  };

  const invitarUsuario = async () => {
    if (!invitacion.email || !invitacion.nombre) return;
    setEnviandoInvitacion(true);
    setMensajeInvitacion('');
    try {
      const { error } = await supabase.auth.admin.inviteUserByEmail(invitacion.email, {
        data: { nombre: invitacion.nombre, empresa_id: empresaId, rol: invitacion.rol }
      });
      if (error) throw error;
      setMensajeInvitacion('✓ Invitación enviada a ' + invitacion.email);
      setInvitacion({ email: '', nombre: '', rol: 'ejecutivo' });
      setShowInvitar(false);
    } catch (e) {
      setMensajeInvitacion('Error al enviar: ' + e.message);
    }
    setEnviandoInvitacion(false);
  };

  const agregarHito = async () => {
    if (!nuevoHito.nombre) return;
    const { data } = await crearHitoConfig({ empresa_id: empresaId, ...nuevoHito, activo: true, orden: hitos.length + 1 });
    if (data) setHitos([...hitos, data]);
    setNuevoHito({ nombre: '', fotos: false, aprobacion: 'manual', palabras_clave: '' });
    setShowNuevoHito(false);
  };

  const guardarEdicionHito = async (hito) => {
    await actualizarHitoConfig(hito.id, { nombre: hito.nombre, aprobacion: hito.aprobacion, palabras_clave: hito.palabras_clave, activo: hito.activo, fotos: hito.fotos });
    setHitos(hitos.map(h => h.id === hito.id ? hito : h));
    setEditandoHito(null);
  };

  const toggleHito = async (id, campo) => {
    const hito = hitos.find(h => h.id === id);
    const nuevoValor = !hito[campo];
    await actualizarHitoConfig(id, { [campo]: nuevoValor });
    setHitos(hitos.map(h => h.id === id ? { ...h, [campo]: nuevoValor } : h));
  };

  const borrarHito = async (id) => {
    await eliminarHitoConfig(id);
    setHitos(hitos.filter(h => h.id !== id));
  };

  const guardarPlantilla = async (id) => {
    await actualizarPlantilla(id, { texto: editData.texto, descripcion: editData.hito_nombre });
    setPlantillas(plantillas.map(p => p.id === id ? { ...p, texto: editData.texto, descripcion: editData.hito_nombre } : p));
    setEditandoPlantilla(null);
  };

  const borrarPlantilla = async (id) => {
    await eliminarPlantilla(id);
    setPlantillas(plantillas.filter(p => p.id !== id));
  };

  const agregarPlantilla = async () => {
    if (!nuevaPlantilla.titulo) return;
    const { data } = await crearPlantilla({
      empresa_id: empresaId,
      titulo: nuevaPlantilla.titulo,
      descripcion: nuevaPlantilla.hito_nombre,
      texto: nuevaPlantilla.texto,
    });
    if (data) setPlantillas([...plantillas, data]);
    setNuevaPlantilla({ titulo: '', hito_nombre: '', texto: '' });
    setShowNuevaPlantilla(false);
  };

  const tabs = [
    { id: 'empresa', label: 'Empresa' },
    { id: 'usuarios', label: 'Usuarios' },
    { id: 'hitos', label: 'Hitos' },
    { id: 'plantillas', label: 'Plantillas' },
  ];

  const s = {
    card: { background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px', marginBottom: '20px' },
    label: { fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' },
    input: { width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '10px 12px', color: '#e8eaf0', fontSize: '13px' },
    inputSm: { background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '6px 10px', color: '#e8eaf0', fontSize: '13px' },
    inputEdit: { background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '6px 10px', color: '#e8eaf0', fontSize: '13px' },
    btnGreen: { background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
    btnOutline: { background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer' },
    btnSmOutline: { background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '5px 8px', fontSize: '11px', cursor: 'pointer' },
    btnDanger: { background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '14px' },
    btnVar: { background: 'rgba(59,130,246,0.1)', border: '1px solid rgba(59,130,246,0.2)', color: '#3b82f6', borderRadius: '4px', padding: '3px 8px', fontSize: '11px', cursor: 'pointer', fontFamily: 'monospace', fontWeight: '600' },
    toggle: (on) => ({ width: '36px', height: '20px', borderRadius: '10px', background: on ? '#00e5a0' : '#222730', cursor: 'pointer', position: 'relative', flexShrink: 0 }),
    toggleDot: (on) => ({ width: '14px', height: '14px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '3px', left: on ? '19px' : '3px', transition: 'left 0.2s' }),
    sectionTitle: { fontSize: '13px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '16px' },
    th: { fontSize: '10px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', padding: '12px 20px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' },
    td: { padding: '12px 20px' },
  };

  const moverHito = (fromIdx, toIdx) => {
    const nuevos = [...hitos];
    const [moved] = nuevos.splice(fromIdx, 1);
    nuevos.splice(toIdx, 0, moved);
    const actualizados = nuevos.map((h, i) => ({ ...h, orden: i + 1 }));
    setHitos(actualizados);
    actualizados.forEach(h => actualizarHitoConfig(h.id, { orden: h.orden }));
  };
  return (
    <div style={{ padding: '28px 32px' }}>
      <div style={{ display: 'flex', gap: '4px', marginBottom: '28px', borderBottom: '1px solid #222730' }}>
        {tabs.map(tab => (
          <div key={tab.id} onClick={() => setActiveTab(tab.id)}
            style={{ padding: '10px 20px', cursor: 'pointer', fontSize: '13px', fontWeight: '500', color: activeTab === tab.id ? '#00e5a0' : '#6b7280', borderBottom: activeTab === tab.id ? '2px solid #00e5a0' : '2px solid transparent', marginBottom: '-1px' }}>
            {tab.label}
          </div>
        ))}
      </div>

      {/* ── EMPRESA ── */}
      {activeTab === 'empresa' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 380px', gap: '20px', alignItems: 'start' }}>
          <div style={s.card}>
            <div style={s.sectionTitle}>Datos de la Empresa</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {[['nombre','Nombre'],['rfc','RFC'],['telefono','Teléfono'],['email','Email']].map(([k,l]) => (
                <div key={k}>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>{l}</div>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: '#e8eaf0' }}>{empresa[k] || '—'}</div>
                </div>
              ))}
            </div>
            <div style={{ marginTop: '24px', borderTop: '1px solid #222730', paddingTop: '20px' }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '12px' }}>Logo de la empresa</div>
              {empresa.logo_url && (
                <img src={empresa.logo_url} alt="Logo" style={{ height: '48px', marginBottom: '12px', display: 'block', objectFit: 'contain' }} />
              )}
              <input type="file" accept="image/png,image/jpeg,image/svg+xml" id="logo-upload"
                style={{ display: 'none' }} onChange={async (e) => {
                  const archivo = e.target.files[0];
                  if (!archivo) return;
                  const { url, error } = await subirLogo(empresaId, archivo);
                  if (!error && url) {
                    await actualizarEmpresa(empresaId, { logo_url: url });
                    setEmpresa({ ...empresa, logo_url: url });
                  }
                }} />
              <label htmlFor="logo-upload" style={{ display: 'inline-block', background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', color: '#00e5a0', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
                {empresa.logo_url ? 'Cambiar logo' : 'Subir logo'}
              </label>
              <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '8px' }}>PNG, JPG o SVG. Se usará en documentos generados.</div>
            </div>
            <div style={{ marginTop: '24px', padding: '12px 16px', background: 'rgba(0,229,160,0.05)', border: '1px solid rgba(0,229,160,0.15)', borderRadius: '8px', fontSize: '12px', color: '#6b7280' }}>
              ℹ️ Los datos de la empresa se configuran durante el onboarding. Contacta a soporte si necesitas hacer cambios.
            </div>
          </div>
          <div style={{ background: 'linear-gradient(135deg, rgba(0,229,160,0.06) 0%, rgba(139,92,246,0.06) 100%)', border: '1px solid rgba(0,229,160,0.2)', borderRadius: '12px', padding: '28px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div style={{ fontSize: '16px', fontWeight: '700', color: '#ffffff', lineHeight: 1.3 }}>¿Buscas más capacidad o personalizar aún más?</div>
            <div style={{ fontSize: '13px', color: '#9ca3af', lineHeight: 1.7 }}>
              Te ayudamos a crecer. Nuestros ejecutivos pueden diseñar un plan a la medida de tu operación — más usuarios, integraciones personalizadas, automatizaciones avanzadas y soporte dedicado.
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {['Usuarios ilimitados', 'Integraciones a la medida', 'Automatizaciones WhatsApp', 'SLA garantizado'].map(f => (
                <div key={f} style={{ display: 'flex', gap: '8px', alignItems: 'center', fontSize: '13px', color: '#e8eaf0' }}>
                  <span style={{ color: '#00e5a0', fontSize: '12px' }}>✓</span> {f}
                </div>
              ))}
            </div>
            <a href="https://wa.me/5218112345678?text=Hola,%20me%20interesa%20mejorar%20mi%20plan%20de%20LogiConnect" target="_blank" rel="noreferrer"
              style={{ display: 'block', textAlign: 'center', background: '#00e5a0', color: '#000', borderRadius: '8px', padding: '12px', fontSize: '14px', fontWeight: '700', textDecoration: 'none', marginTop: '8px' }}>
              Hablar con un ejecutivo →
            </a>
            <a href="https://wa.me/5218112345678" target="_blank" rel="noreferrer"
              style={{ display: 'block', textAlign: 'center', background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.3)', color: '#25d366', borderRadius: '8px', padding: '10px', fontSize: '13px', fontWeight: '600', textDecoration: 'none' }}>
              💬 WhatsApp directo
            </a>
          </div>
        </div>
      )}

      {/* ── USUARIOS ── */}
      {activeTab === 'usuarios' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <div style={{ fontSize: '14px', color: '#9ca3af' }}>{usuarios.length} usuarios registrados</div>
            <button onClick={() => { setShowInvitar(true); setMensajeInvitacion(''); }} style={s.btnGreen}>+ Invitar usuario</button>
          </div>

          {mensajeInvitacion && (
            <div style={{ padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', background: mensajeInvitacion.startsWith('Error') ? 'rgba(239,68,68,0.08)' : 'rgba(0,229,160,0.08)', border: `1px solid ${mensajeInvitacion.startsWith('Error') ? 'rgba(239,68,68,0.3)' : 'rgba(0,229,160,0.2)'}`, fontSize: '13px', color: mensajeInvitacion.startsWith('Error') ? '#ef4444' : '#00e5a0' }}>
              {mensajeInvitacion}
            </div>
          )}

          {showInvitar && (
            <div style={{ ...s.card, border: '1px solid #00e5a0', marginBottom: '20px' }}>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff', marginBottom: '16px' }}>Invitar Usuario</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                <div>
                  <label style={s.label}>Nombre completo</label>
                  <input value={invitacion.nombre} onChange={e => setInvitacion({...invitacion, nombre: e.target.value})} placeholder="Ana García" style={s.input} />
                </div>
                <div>
                  <label style={s.label}>Email</label>
                  <input value={invitacion.email} onChange={e => setInvitacion({...invitacion, email: e.target.value})} placeholder="correo@empresa.com" style={s.input} />
                </div>
                <div>
                  <label style={s.label}>Rol</label>
                  <select value={invitacion.rol} onChange={e => setInvitacion({...invitacion, rol: e.target.value})} style={s.input}>
                    <option value="ejecutivo">Ejecutivo</option>
                    <option value="admin">Administrador</option>
                  </select>
                </div>
              </div>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '16px' }}>
                Se enviará un email de invitación. El usuario deberá crear su contraseña al aceptar.
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button onClick={invitarUsuario} disabled={enviandoInvitacion} style={s.btnGreen}>
                  {enviandoInvitacion ? 'Enviando...' : 'Enviar invitación'}
                </button>
                <button onClick={() => setShowInvitar(false)} style={s.btnOutline}>Cancelar</button>
              </div>
            </div>
          )}

          <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr>{['Nombre','Email','Rol','Estado'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {usuarios.map((u, i) => (
                  <tr key={u.id} style={{ background: i%2===0?'transparent':'#0d1117' }}>
                    <td style={{...s.td, fontSize:'13px', color:'#e8eaf0', fontWeight:'500'}}>{u.nombre}</td>
                    <td style={{...s.td, fontSize:'12px', color:'#6b7280'}}>{u.email}</td>
                    <td style={s.td}>
                      <span style={{ fontSize:'11px', fontWeight:'600', padding:'3px 10px', borderRadius:'10px', background: u.rol==='admin'?'rgba(139,92,246,0.1)':'rgba(59,130,246,0.1)', color: u.rol==='admin'?'#8b5cf6':'#3b82f6' }}>
                        {u.rol==='admin'?'Administrador':'Ejecutivo'}
                      </span>
                    </td>
                    <td style={{...s.td, fontSize:'11px', fontWeight:'600', color: u.activo?'#00e5a0':'#6b7280'}}>
                      {u.activo?'● Activo':'○ Inactivo'}
                    </td>
                  </tr>
                ))}
                {usuarios.length === 0 && (
                  <tr><td colSpan="4" style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin usuarios registrados</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── HITOS ── */}
      {activeTab === 'hitos' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <div style={{ fontSize: '14px', color: '#9ca3af' }}>{hitos.length} hitos configurados</div>
            <button onClick={() => setShowNuevoHito(true)} style={s.btnGreen}>+ Agregar hito</button>
          </div>
          {showNuevoHito && (
            <div style={{ ...s.card, border: '1px solid #00e5a0' }}>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff', marginBottom: '16px' }}>Nuevo Hito</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                <div>
                  <label style={s.label}>Nombre</label>
                  <input value={nuevoHito.nombre} onChange={e => setNuevoHito({...nuevoHito, nombre: e.target.value})} placeholder="Ej: Revisión aduanal" style={s.input} />
                </div>
                <div>
                  <label style={s.label}>Aprobación</label>
                  <select value={nuevoHito.aprobacion} onChange={e => setNuevoHito({...nuevoHito, aprobacion: e.target.value})} style={s.input}>
                    <option value="manual">Manual</option>
                    <option value="auto">Automática</option>
                  </select>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingTop: '20px' }}>
                  <div onClick={() => setNuevoHito({...nuevoHito, fotos: !nuevoHito.fotos})} style={s.toggle(nuevoHito.fotos)}>
                    <div style={s.toggleDot(nuevoHito.fotos)}></div>
                  </div>
                  <span style={{ fontSize: '13px', color: '#9ca3af' }}>Fotos requeridas</span>
                </div>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={s.label}>Palabras clave</label>
                <input value={nuevoHito.palabras_clave} onChange={e => setNuevoHito({...nuevoHito, palabras_clave: e.target.value})} placeholder="ej: llegada, llegué, en carga" style={s.input} />
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button onClick={agregarHito} style={s.btnGreen}>Agregar</button>
                <button onClick={() => setShowNuevoHito(false)} style={s.btnOutline}>Cancelar</button>
              </div>
            </div>
          )}
          <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>{['', 'Hito','Palabras clave','Color','Activo','Fotos','Aprobación','Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {hitos.map((h, i) => (
                  <tr key={h.id}
                    draggable
                    onDragStart={() => setDraggingHito(i)}
                    onDragOver={e => e.preventDefault()}
                    onDrop={() => { if (draggingHito !== null && draggingHito !== i) moverHito(draggingHito, i); setDraggingHito(null); }}
                    style={{ background: draggingHito === i ? 'rgba(0,229,160,0.08)' : i%2===0?'transparent':'#0d1117', opacity: h.activo?1:0.5, cursor: 'grab' }}>
                    <td style={{ ...s.td, width: '20px', color: '#6b7280', fontSize: '16px', cursor: 'grab' }}>⠿</td>
                    <td style={s.td}>
                      {editandoHito === h.id
                        ? <input value={h.nombre} onChange={e => setHitos(hitos.map(x => x.id===h.id ? {...x, nombre: e.target.value} : x))} style={{...s.inputEdit, width:'180px'}} />
                        : <span style={{ fontSize:'13px', fontWeight:'500', color:'#e8eaf0' }}>{h.nombre}</span>}
                    </td>
                    <td style={s.td}>
                      {editandoHito === h.id
                        ? <input value={h.palabras_clave || ''} onChange={e => setHitos(hitos.map(x => x.id===h.id ? {...x, palabras_clave: e.target.value} : x))} placeholder="ej: saliendo, en camino" style={{...s.inputEdit, width:'200px'}} />
                        : <span style={{ fontSize:'11px', color:'#6b7280' }}>{h.palabras_clave || '—'}</span>}
                    </td>
                    <td style={s.td}>
                      <input type="color" value={h.color || '#00e5a0'}
                        onChange={e => { const c = e.target.value; setHitos(hitos.map(x => x.id===h.id ? {...x, color: c} : x)); actualizarHitoConfig(h.id, { color: c }); }}
                        style={{ width: '36px', height: '28px', borderRadius: '6px', border: '1px solid #222730', cursor: 'pointer', background: 'transparent' }} />
                    </td>
                    <td style={s.td}>
                      <div onClick={() => toggleHito(h.id, 'activo')} style={s.toggle(h.activo)}>
                        <div style={s.toggleDot(h.activo)}></div>
                      </div>
                    </td>
                    <td style={s.td}>
                      <div onClick={() => toggleHito(h.id, 'fotos')} style={s.toggle(h.fotos)}>
                        <div style={s.toggleDot(h.fotos)}></div>
                      </div>
                    </td>
                    <td style={s.td}>
                      {editandoHito === h.id
                        ? <select value={h.aprobacion} onChange={e => setHitos(hitos.map(x => x.id===h.id ? {...x, aprobacion: e.target.value} : x))} style={s.inputSm}>
                            <option value="manual">Manual</option>
                            <option value="auto">Automática</option>
                          </select>
                        : <span style={{ fontSize:'12px', fontWeight:'600', color: h.aprobacion==='manual'?'#f59e0b':'#00e5a0' }}>{h.aprobacion==='manual'?'Manual':'Automática'}</span>}
                    </td>
                    <td style={s.td}>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        {editandoHito === h.id
                          ? <>
                              <button onClick={() => guardarEdicionHito(h)} style={s.btnGreen}>💾</button>
                              <button onClick={() => setEditandoHito(null)} style={s.btnSmOutline}>✕</button>
                            </>
                          : <>
                              <button onClick={() => setEditandoHito(h.id)} style={s.btnSmOutline}>✏️</button>
                              <button onClick={() => borrarHito(h.id)} style={s.btnDanger}>🗑️</button>
                            </>}
                      </div>
                    </td>
                  </tr>
                ))}
                {hitos.length === 0 && (
                  <tr><td colSpan="7" style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin hitos configurados</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── PLANTILLAS ── */}
      {activeTab === 'plantillas' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: '13px', color: '#6b7280' }}>Haz clic en una variable para insertarla en el mensaje</div>
            <button onClick={() => setShowNuevaPlantilla(true)} style={s.btnGreen}>+ Nueva plantilla</button>
          </div>

          {showNuevaPlantilla && (
            <div style={{ ...s.card, border: '1px solid #00e5a0' }}>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff', marginBottom: '16px' }}>Nueva Plantilla</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                <div>
                  <label style={s.label}>Título</label>
                  <input value={nuevaPlantilla.titulo} onChange={e => setNuevaPlantilla({...nuevaPlantilla, titulo: e.target.value})} placeholder="Ej: Mensaje de salida" style={s.input} />
                </div>
                <div>
                  <label style={s.label}>Hito enlazado</label>
                  <select value={nuevaPlantilla.hito_nombre} onChange={e => setNuevaPlantilla({...nuevaPlantilla, hito_nombre: e.target.value})} style={s.input}>
                    <option value="">Sin hito específico</option>
                    {hitos.map(h => <option key={h.id} value={h.nombre}>{h.nombre}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ marginBottom: '8px' }}>
                <label style={s.label}>Insertar variable</label>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '8px' }}>
                  {VARIABLES.map(v => (
                    <button key={v} onClick={() => insertarVariable(v, textareaNuevoRef, nuevaPlantilla.texto, (val) => setNuevaPlantilla({...nuevaPlantilla, texto: val}))} style={s.btnVar}>{v}</button>
                  ))}
                </div>
              </div>
              <div style={{ marginBottom: '16px' }}>
                <label style={s.label}>Mensaje</label>
                <textarea ref={textareaNuevoRef} value={nuevaPlantilla.texto} onChange={e => setNuevaPlantilla({...nuevaPlantilla, texto: e.target.value})}
                  placeholder="Ej: Tu carga está en camino. Conductor: {conductor} | Ruta: {ruta}"
                  style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '10px 12px', color: '#e8eaf0', fontSize: '13px', minHeight: '80px', resize: 'vertical', fontFamily: 'monospace' }} />
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button onClick={agregarPlantilla} style={s.btnGreen}>Agregar plantilla</button>
                <button onClick={() => setShowNuevaPlantilla(false)} style={s.btnOutline}>Cancelar</button>
              </div>
            </div>
          )}

          {plantillas.map(p => (
            <div key={p.id} style={s.card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                <div>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff', marginBottom: '4px' }}>{p.titulo}</div>
                  {p.descripcion && <div style={{ fontSize: '11px', color: '#00e5a0' }}>📋 Hito: {p.descripcion}</div>}
                </div>
                {editandoPlantilla !== p.id
                  ? <div style={{ display: 'flex', gap: '6px' }}>
                      <button onClick={() => { setEditandoPlantilla(p.id); setEditData({ texto: p.texto || '', hito_nombre: p.descripcion || '' }); }} style={s.btnSmOutline}>✏️ Editar</button>
                      <button onClick={() => borrarPlantilla(p.id)} style={s.btnDanger}>🗑️</button>
                    </div>
                  : <div style={{ display: 'flex', gap: '8px' }}>
                      <button onClick={() => guardarPlantilla(p.id)} style={s.btnGreen}>💾 Guardar</button>
                      <button onClick={() => setEditandoPlantilla(null)} style={s.btnOutline}>Cancelar</button>
                    </div>}
              </div>

              {editandoPlantilla === p.id ? (
                <div>
                  <div style={{ marginBottom: '12px' }}>
                    <label style={s.label}>Hito enlazado</label>
                    <select value={editData.hito_nombre} onChange={e => setEditData({...editData, hito_nombre: e.target.value})} style={{...s.input, border: '1px solid #00e5a0'}}>
                      <option value="">Sin hito específico</option>
                      {hitos.map(h => <option key={h.id} value={h.nombre}>{h.nombre}</option>)}
                    </select>
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    <label style={s.label}>Insertar variable</label>
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '8px' }}>
                      {VARIABLES.map(v => (
                        <button key={v} onClick={() => insertarVariable(v, textareaEditRef, editData.texto, (val) => setEditData({...editData, texto: val}))} style={s.btnVar}>{v}</button>
                      ))}
                    </div>
                  </div>
                  <textarea ref={textareaEditRef} value={editData.texto} onChange={e => setEditData({...editData, texto: e.target.value})}
                    style={{ width: '100%', background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '12px', color: '#e8eaf0', fontSize: '13px', minHeight: '80px', resize: 'vertical', fontFamily: 'monospace' }} />
                </div>
              ) : (
                <div style={{ background: '#181c24', borderRadius: '6px', padding: '12px', fontSize: '13px', color: '#9ca3af', fontFamily: 'monospace', lineHeight: 1.6 }}>{p.texto || '—'}</div>
              )}
            </div>
          ))}

          {plantillas.length === 0 && !showNuevaPlantilla && (
            <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin plantillas configuradas</div>
          )}
        </div>
      )}
    </div>
  );
}
